import "./FullEventBlock.css"
import Icon from "../../../../components/elements/Icons/Icon";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { deleteEventByID, getApiErrorMessage } from "../../../../api/api";
import { getResponsiveImageVariables } from "../../../../utils/imagePosition";

export default function FullEventBlock({ 
    title, 
    description, 
    date, 
    image,
    imagePosition,
    imagePositionMobile,
    imageStyle = {},
    imageStyleMobile = {},
    hex,
    actionType = 'view',
    fontSizeDescription,
    links,
    style,
    previewMode = 'desktop'
}) {
    let currentImage = null;
    const { id } = useParams()
    const navigate = useNavigate()
    
    if (image) {
        if (image.startsWith('blob:') || image.startsWith('http')) {
            currentImage = image;
        } else {
            currentImage = `/uploads/events/${image}`;
        }
    }

    const baseStyle = {
        pointerEvents: 'none',
        userSelect: 'none',
        ...getResponsiveImageVariables(imagePosition, imagePositionMobile),
    };

    console.log("fontSizeDescription: ", fontSizeDescription)


    const combinedStyles = {
        pointerEvents: 'none',
        userSelect: 'none',
        ...getResponsiveImageVariables(imagePosition, imagePositionMobile, imageStyle, imageStyleMobile),
    };

    
    const deleteEvent = async (id) => {
        const isConfirmed = window.confirm('Czy na pewno chcesz usunąć to wydarzenie?');

        if (!isConfirmed) {
            return;
        }

        try {
            const response = await deleteEventByID(id)
            if ((response?.data?.cleanup_warnings || 0) > 0) {
                alert('Wydarzenie usunięto z bazy, ale niektórych plików nie udało się usunąć. Sprawdź log serwera.');
            }
            navigate('/events', { replace: true })
        } catch (error) {
            console.error('Błąd usuwania:', error);
            alert(`❌ ${getApiErrorMessage(error, 'Wystąpił błąd podczas usuwania!')}`);
        }
    };

    return (
        <div className={`inline-pen full-event-card-shell ${previewMode === 'mobile' ? 'full-event-mobile-preview' : ''}`} style={ style }>
            <div className="full-container" style={{ borderColor: hex.secondary, '--event-background': hex.background }}>
                <div className="full-bg">
                    <div 
                        className="full-gradient-overlay"
                        style={{
                            background: `linear-gradient(to right, ${hex.background} 31%, rgba(0, 0, 0, 0) 100%)`
                        }}
                    ></div>
                    {currentImage ? (
                        <img
                            src={currentImage}
                            alt={title || 'Wydarzenie'}
                            style={actionType === 'view' ? baseStyle : combinedStyles}
                            className="full-event-positioned-image"
                            draggable={false}
                        />
                    ) : (
                        <div className="full-no-image">
                            <span>Brak obrazu</span>
                        </div>
                    )}
                </div>
                <div className="full-content">
                    <h1 style={{ color: hex.primary }}>{title || 'Bez tytułu'}</h1>
                    <h4 style={{ color: hex.primary, fontSize: `${fontSizeDescription}px` }}>{description || 'Brak opisu'}</h4>

                    <div className="full-bottom-container">
                        { (Array.isArray(links) ? links : []).map(link => {
                            if (link.link && link.link !== '') {
                                return (
                                    <a key={`${link.name}-${link.link}`} href={`${link.link ?? "#"}`} target="_blank" rel="noreferrer">
                                        <Icon name={link.name} width={25} height={25} color={ hex.secondary } />
                                    </a>
                                )
                            }
                            return null;
                        }) }
                        
                        <div className="full-vertical-line" style={{ backgroundColor: hex.secondary, display: !Array.isArray(links) || links.length === 0 ? 'none' : 'block'}}></div>
                        <div className="full-date-block">
                            <Icon name={"calendar"} width={30} color={ hex.secondary } />
                            <span style={{ color: hex.secondary }}>{date || 'Brak daty'}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            { localStorage.getItem("isAdmin") === 'true' && actionType !== 'edit' && actionType === "view" ? 
            <div className="full-event-container-horizontal-button">
                <NavLink to={"/edit-event/" + id}>
                    <div className="pen-block">
                        <Icon name={"pen"} />
                    </div>
                </NavLink>
                <div className="full-pen-block" onClick={ () => deleteEvent(id) }>
                    <Icon name={"trash"} />
                </div>
            </div> :
            ""
            }
        </div>
    )
}
